/**
 * Schema Info Panel Component
 * 
 * Displays informational cards about the database schema design,
 * type safety, and data integrity features.
 */

import React from 'react';

export default function SchemaInfoPanel() {
  return (
    <div className="p-4 bg-muted/30 border-b">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
        <div className="bg-card p-3 rounded border">
          <h4 className="font-medium text-blue-600 mb-2">Schema Design</h4>
          <p className="text-muted-foreground">
            Normalized relational structure with junction tables for many-to-many relationships
          </p>
        </div>
        <div className="bg-card p-3 rounded border">
          <h4 className="font-medium text-green-600 mb-2">Type Safety</h4>
          <p className="text-muted-foreground">
            TypeScript interfaces with Drizzle ORM schema validation
          </p>
        </div>
        <div className="bg-card p-3 rounded border">
          <h4 className="font-medium text-purple-600 mb-2">Data Integrity</h4>
          <p className="text-muted-foreground">
            Primary keys, foreign key constraints, and required field validation
          </p>
        </div>
      </div>
    </div>
  );
}
